/* eslint-disable react/prop-types */
import { Box } from "@mui/material";
// import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
// import DialogTitle from "@mui/material/DialogTitle";
import * as React from "react";
// import Button from "../Layout/Button";
import Button from "../../../../components/Layout/Button/index";
import Modal from "../../../../components/Modal/Modal";
// import Typography from "../Typography/Typography";
import Typography from "../../../../components/Typography/Typography";

export default function SendEmailAlert({ open, onClose, onSubmit }) {
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      onSubmit();
    }
  };
  return (
    <Box tabIndex="0" onKeyPress={handleKeyPress}>
      <Modal
        open={open}
        onClose={onClose}
        // fullWidth="50%"
        // PaperProps={{ sx: { minHeight: 100 } }}
        // aria-labelledby="alert-dialog-title"
        // aria-describedby="alert-dialog-description"
      >
        {/* <Typography
          style={{
            // color: "#8C8C8C",
            fontSize: "20px ",
            fontWeight: "500",
            paddingBottom: "20px",
          }}
        >
          Contribution recorded successfully!!
        </Typography> */}
        <Typography
          style={{
            // color: "#8C8C8C",
            fontSize: "20px ",
            fontWeight: "500",
            paddingBottom: "20px",
          }}
        >
          Do you want to continue and send the email?
        </Typography>
        <Box
          style={{
            display: "flex",
            // paddingTop: "50px",
            justifyContent: "space-between",
            marginTop: "20px",
          }}
        >
          {/* <Button
            onClick={onSubmit}
            label="Yes"
            style={{
              marginRight: "10px",
            }}
          /> */}
          <Button
            onClick={onSubmit}
            width="40%"
            style={{
              marginRight: "10px",
              //   width: "50%",
            }}
          >
            Yes
          </Button>
          <Button onClick={onClose} cancel width="40%">
            No
          </Button>
          {/* <Button onClick={onClose} label="No" variant="outlined" /> */}
        </Box>
      </Modal>
    </Box>
  );
}
